var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.9 19.8h-1.1a2.164 2.164 0 0 1-2.01-1.48q-.27-.75-.6-1.47a2.152 2.152 0 0 1 .37-2.47l.77-.77a2.1 2.1 0 0 0 0-2.97l-2.97-2.97a2.1 2.1 0 0 0-2.97 0l-.77.77a2.152 2.152 0 0 1-2.47.37q-.72-.33-1.47-.6A2.164 2.164 0 0 1 28.2 6.2V5.1A2.1 2.1 0 0 0 26.1 3h-4.2a2.1 2.1 0 0 0-2.1 2.1v1.1a2.164 2.164 0 0 1-1.48 2.01q-.75.27-1.47.6a2.152 2.152 0 0 1-2.47-.37l-.77-.77a2.1 2.1 0 0 0-2.97 0l-2.97 2.97a2.1 2.1 0 0 0 0 2.97l.77.77a2.152 2.152 0 0 1 .37 2.47q-.33.72-.6 1.47A2.164 2.164 0 0 1 6.2 19.8H5.1A2.1 2.1 0 0 0 3 21.9v4.2a2.1 2.1 0 0 0 2.1 2.1h.05A3.807 3.807 0 0 1 8.9 25h2.7a3.694 3.694 0 0 1 1.48.3A11.19 11.19 0 0 1 13 24a11 11 0 1 1 20.86 4.88l3.39-2.52.1-.06a5.093 5.093 0 0 1 2.52-.68 5.009 5.009 0 0 1 2.25.54 4.953 4.953 0 0 1 1.93 1.69A2.09 2.09 0 0 0 45 26.1v-4.2a2.1 2.1 0 0 0-2.1-2.1Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.865 30.204a2.967 2.967 0 0 0-1.637-2.259 3.03 3.03 0 0 0-2.88.09l-9.998 7.434a3.466 3.466 0 0 1-1.71.45h-4.257a1.143 1.143 0 1 1 0-2.286h3.123a2.029 2.029 0 0 0 2.025-1.998v-.036a2.026 2.026 0 0 0-2.025-2.016H14.751V43.2a2.364 2.364 0 0 1-.036.441h12.958a6.318 6.318 0 0 0 4.248-1.638l9.765-8.892a3.228 3.228 0 0 0 1.18-2.907Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.3,
    height: 18,
    x: 7.101,
    y: 27,
    rx: 1.8,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemManagement);
export default __webpack_public_path__ + "static/media/system_management.a28b1d74a670c7180b360ccafa8ea6d8.svg";
export { ForwardRef as ReactComponent };